import { z } from 'zod';

import type {
  MarkShipmentDepartedRequest,
  MarkShipmentDepartedResponse,
} from './mark-shipment-departed.dto.js';
import {
  ShipmentHeaderSchema,
} from './shipments-shared.schema.js';
import { IsoDateTimeSchema } from './shipments-types.js';

export const MarkShipmentDepartedRequestSchema: z.ZodType<MarkShipmentDepartedRequest> = z
  .object({
    companyId: z.uuid(),
    shipmentId: z.uuid(),
    stationId: z.uuid(),
    departedAt: IsoDateTimeSchema.optional(),
  })
  .strict();

export const MarkShipmentDepartedResponseSchema: z.ZodType<MarkShipmentDepartedResponse> = z
  .object({
    shipment: ShipmentHeaderSchema,
  })
  .strict();
